import track from '../track';
import events from '../eventNames';

/**
 * Track Clicked Vet Portal On Home Vet
 */
export function trackHomeVetClickedVetPortal() {
  track(events.homepage_vet_section_clicked_vet_portal);
}
